<div class="modal-header no-print" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">picture_as_pdf</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">{{ tituloDocumento }} @if (dados) { Nº {{ numeroDocumento }} }</h2>
    <span class="modal-subtitle">Prévia do PDF</span>
  </div>
  @if (isPedido && dados) {
    <button mat-stroked-button type="button" class="btn-filter vdi-btn-layout" [matMenuTriggerFor]="menuLayout" aria-label="Layout da impressão">
      layout {{ rotuloLayout(layout) }}
      <mat-icon iconPositionEnd class="material-symbols-outlined">arrow_drop_down</mat-icon>
    </button>
    <mat-menu #menuLayout="matMenu" class="vdi-menu-layout">
      @for (opcao of layouts; track opcao) {
        <button mat-menu-item type="button" [class.vdi-layout-ativo]="opcao === layout" (click)="alterarLayout(opcao)">
          layout {{ rotuloLayout(opcao) }}
        </button>
      }
    </mat-menu>
  }
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="fechar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  @if (isCarregando) {
    <div class="vdi-carregando" aria-busy="true">
      <mat-spinner diameter="48"></mat-spinner>
      <span>Montando a prévia…</span>
    </div>
  } @else if (dados) {
    <app-venda-folha [dados]="dados" [layout]="layout"></app-venda-folha>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-footer no-print">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()">Cancelar</button>
  <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isImprimindo"
    [disabled]="isCarregando || !dados || isImprimindo" [attr.aria-label]="isImprimindo ? 'Gerando PDF' : 'Gerar PDF'"
    (click)="imprimir()">
    <mat-icon class="material-symbols-outlined">picture_as_pdf</mat-icon>
    Gerar PDF
    @if (isImprimindo) { <mat-spinner diameter="20"></mat-spinner> }
  </button>
</mat-dialog-actions>
